import React, { useEffect } from 'react';
import '../App.css';
import { useTranslation } from '../contexts/LanguageContext';
import { useUrlManagement } from '../hooks/useUrlManagement';
import { useGameStore } from '../store/gameStore';
import { GameBoard } from './GameBoard';

export const SpymasterView: React.FC = () => {
  const { setSpymasterMode } = useGameStore();
  const { t } = useTranslation();
  
  // Initialize URL management to load board from URL
  useUrlManagement();
  
  // Enable spymaster mode when component mounts
  useEffect(() => {
    setSpymasterMode(true);
  }, [setSpymasterMode]);

  return (
    <div className="App">
      <div className="game-container">
        <h1 className="game-title">KODENAMES - {t.spymasterView}</h1>
        <GameBoard />
      </div>
    </div>
  );
};
